import * as z from 'zod'

import { CONTENTS_CONSTANTS } from '@flows/configs/contents/constants'
import type { ContentsNeoStepConfigParams } from '@flows/configs/contents/types'
import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import * as validators from '@flows/configs/shared/validators'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { FAILURE_STEP_NAME } from '@flows/insurance/constants'
import { BaseSchema_ContentsPremiumBasicNeodigitalDe } from '@flows/insurance/schemas'

const claimsOptionsFromSchema = schemaUtils.getEnumValuesFromPipelineSchema(
  BaseSchema_ContentsPremiumBasicNeodigitalDe.shape.number_of_previous_claims
)

const contents_damages = (params: ContentsNeoStepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('number_of_claims_in_last_5y')]:
        validators.createPreprocessedEnumNumberSchema(z.enum([...claimsOptionsFromSchema, '3'])),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_contents:steps.contents.damages.title',
        },
      },
      {
        type: 'choice',
        name: params.helperFunctions.getParamPath('number_of_prior_claims'),
        options: CONTENTS_CONSTANTS.claimsOptions,
      },
    ],
    subFlow: params.subFlow,
    nextStepConfig: {
      valuePath: params.helperFunctions.getParamPath('number_of_prior_claims'),
      valueToStepName: {
        '0': 'contents_insurance_cancelled',
        '1': 'contents_insurance_cancelled',
        '2': 'contents_insurance_cancelled',
        '3': FAILURE_STEP_NAME,
      },
    },
  }) as const satisfies AnyStepConfiguration

export default contents_damages
